import LyForm from './src/index.vue'

LyForm.install = function (Vue) {
    Vue.component(LyForm.name, LyForm)
}

export default LyForm



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/form/index.js
// module id = null
// module chunks = 